export enum Themes {
    Success = "border-green-500 bg-green-300",
    Warning = "border-yellow-500 bg-yellow-300",
    Danger = "border-red-700 bg-red-500"
}